import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getApiCaller } from "../../libs/apiCaller";

export const fetchProfile = createAsyncThunk(
  "profile/fetchProfile",
  async () => {
    const response = await getApiCaller("get_profile");
    return response.data?.response_data;
  }
);

const profileSlice = createSlice({
  name: "profile",
  initialState: { data: null, loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProfile.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchProfile.rejected, (state) => {
        state.loading = false;
        state.error = "Failed to fetch profile";
      });
  },
});

export default profileSlice.reducer;
